var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgClockTwoThirtyThin = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 256a240 240 0 1 0 480 0A240 240 0 1 0 16 256zm496 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM248 408l0-152c0-2.7 1.3-5.2 3.6-6.7l96-64c3.7-2.5 8.6-1.5 11.1 2.2s1.5 8.6-2.2 11.1L264 260.3 264 408c0 4.4-3.6 8-8 8s-8-3.6-8-8z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClockTwoThirtyThin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/clock-two-thirty-thin.83906a53.svg";
export { ForwardRef as ReactComponent };